import { render } from "./Appointment.vue?vue&type=template&id=35ff984e&ts=true"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__